export const Strategy = {
	EQUAL_WEIGHT: 'equal weight',
	TREND_FOLLOWING: 'trend following',
	RISK_PARITY: 'risk parity',
	MOMENTUM: 'momentum',
	VOL_TARGET_FILTER: 'volatility targeting',
	FLEXIBLE_WEIGHTS_YOU_CHOOSE: 'flexible weights - you choose'
}